import { createSelector } from 'reselect'

const getLabel = (labels, labelId) => labels.find(label => label.id === labelId);
export const makeGetLabel = () => createSelector(getLabel, labels => labels);

const getLabels = labels => labels
    .filter(label => label && !label.removed)
    .sort((l1, l2) => {
        if (l1.name > l2.name) return 1;
        if (l1.name < l2.name) return -1;

        return 0;
    });
export const makeGetLabels = () => createSelector(getLabels, labels => labels);
